import { render, staticRenderFns } from "./PriceListEditPage.vue?vue&type=template&id=0892c12b&scoped=true"
import script from "./PriceListEditPage.vue?vue&type=script&lang=ts"
export * from "./PriceListEditPage.vue?vue&type=script&lang=ts"
import style0 from "./PriceListEditPage.vue?vue&type=style&index=0&id=0892c12b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0892c12b",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QList,QItem,QItemSection,QSeparator,QItemLabel,QForm,QInput});
